import React from 'react';
import { Print } from '@material-ui/icons';
import logoSvg from '../../images/logo.svg';

const formatDate = (d) => {
  if (!d) return '';
  const date = parseDateValue(d);
  if (!date) return String(d);
  return date.toLocaleDateString('fr-FR');
};

const formatNumber = (n) => (n === 0 || n ? Number(n).toFixed(2) : '0.00');
const parseDateValue = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === 'number') {
    const fromTs = new Date(value);
    return Number.isNaN(fromTs.getTime()) ? null : fromTs;
  }

  if (typeof value !== 'string') return null;

  const input = value.trim();
  if (!input) return null;

  const frMatch = input.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (frMatch) {
    const day = parseInt(frMatch[1], 10);
    const month = parseInt(frMatch[2], 10);
    const year = parseInt(frMatch[3], 10);
    const frDate = new Date(year, month - 1, day);

    if (
      frDate.getFullYear() === year &&
      frDate.getMonth() === month - 1 &&
      frDate.getDate() === day
    ) {
      return frDate;
    }
    return null;
  }

  const isoMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
  if (isoMatch) {
    const year = parseInt(isoMatch[1], 10);
    const month = parseInt(isoMatch[2], 10);
    const day = parseInt(isoMatch[3], 10);
    const isoDate = new Date(year, month - 1, day);

    if (
      isoDate.getFullYear() === year &&
      isoDate.getMonth() === month - 1 &&
      isoDate.getDate() === day
    ) {
      return isoDate;
    }
    return null;
  }

  const generic = new Date(input);
  return Number.isNaN(generic.getTime()) ? null : generic;
};
const getTimestamp = (d) => {
  const date = parseDateValue(d);
  return date ? date.getTime() : 0;
};

const OperationsDrawer = ({ isOpen, onClose, clientName, operations, facturesFacon, loading, dateDebut, dateFin, soldeAnterieur }) => {
  if (!isOpen) return null;

  const sortedOperations = [...(operations || [])].sort((a, b) => {
    const dateA = getTimestamp(a && a.date_saisie);
    const dateB = getTimestamp(b && b.date_saisie);
    return dateA - dateB;
  });

  const sortedFacturesFacon = [...(facturesFacon || [])].sort((a, b) => {
    const dateA = getTimestamp(a && a.date_fact);
    const dateB = getTimestamp(b && b.date_fact);
    return dateA - dateB;
  });

  const handlePrint = () => {
    if ((!sortedOperations || sortedOperations.length === 0) && (!sortedFacturesFacon || sortedFacturesFacon.length === 0) && soldeAnterieur === 0) return;
    
    let totalNet = soldeAnterieur || 0;
    
    // Calculer le total des mouvements pour la période
    let totalPeriode = soldeAnterieur || 0;
    sortedOperations.forEach(op => {
      const isBroutille = op.type_saisie === 'BROUTILLES';
      const isAuto = op.source === 'MOUV_CLIENT';
      const poids750Value = parseFloat(op.poids_750) || 0;
      const tauxPerte = parseFloat(op.taux_perte) || 0;
      
      let displayAmount;
      if (isBroutille) {
        const poidsBrut = parseFloat(op.poids_brut) || poids750Value;
        const perte = poidsBrut * tauxPerte / 100;
        displayAmount = poidsBrut - perte;
      } else if (isAuto) {
        const entreeOrFin = parseFloat(op.entree_or_fin) || 0;
        const sortieOrFin = parseFloat(op.sortie_or_fin) || 0;
        const entree750 = entreeOrFin / 0.751 * 0.95;
        const sortie750 = sortieOrFin / 0.75;
        displayAmount = entree750 - sortie750;
      } else {
        displayAmount = poids750Value;
      }
      totalPeriode += displayAmount;
    });
    
    (sortedFacturesFacon || []).forEach(fac => {
      totalPeriode -= parseFloat(fac.poids) || 0;
    });
    
    
    const soldeAntRow = (dateDebut && soldeAnterieur !== 0) ? `
      <tr style="background: #fff3cd;">
        <td style="padding: 10px 8px; border-bottom: 1px solid #856404; font-weight: 600;">Solde antérieur</td>
        <td style="padding: 10px 8px; border-bottom: 1px solid #856404;">Solde avant le ${formatDate(dateDebut)}</td>
        <td style="padding: 10px 8px; border-bottom: 1px solid #856404; text-align: right; font-weight: 600; color: ${soldeAnterieur >= 0 ? '#34a853' : '#ea4335'};">${formatNumber(soldeAnterieur)} g</td>
      </tr>
    ` : '';
    
    const opRows = sortedOperations.map((op, idx) => {
      const isBroutille = op.type_saisie === 'BROUTILLES';
      const isAuto = op.source === 'MOUV_CLIENT';
      const poids750Value = parseFloat(op.poids_750) || 0;
      const tauxPerte = parseFloat(op.taux_perte) || 0;
      
      let displayAmount;
      if (isBroutille) {
        const poidsBrut = parseFloat(op.poids_brut) || poids750Value;
        const perte = poidsBrut * tauxPerte / 100;
        displayAmount = poidsBrut - perte;
      } else if (isAuto) {
        const entreeOrFin = parseFloat(op.entree_or_fin) || 0;
        const sortieOrFin = parseFloat(op.sortie_or_fin) || 0;
        const entree750 = entreeOrFin / 0.751 * 0.95;
        const sortie750 = sortieOrFin / 0.75;
        displayAmount = entree750 - sortie750;
      } else {
        displayAmount = poids750Value;
      }
      
      return {
        date: op.date_saisie,
        timestamp: getTimestamp(op.date_saisie),
        index: idx,
        description: op.description || op.designation || '—',
        amount: displayAmount
      };
    });

    const facRows = (sortedFacturesFacon || []).map((fac, idx) => {
      const poidsFacon = parseFloat(fac.poids) || 0;
      return {
        date: fac.date_fact,
        timestamp: getTimestamp(fac.date_fact),
        index: idx,
        description: `Facture à façon #${fac.fact} - ${fac.ref} ${fac.ref_clt ? '(' + fac.ref_clt + ')' : ''}`,
        amount: -poidsFacon
      };
    });

    const movementRows = [...opRows, ...facRows]
      .sort((a, b) => {
        if (a.timestamp !== b.timestamp) return a.timestamp - b.timestamp;
        return a.index - b.index;
      })
      .map((row) => {
        totalNet += row.amount;
        return `
        <tr>
          <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">${formatDate(row.date)}</td>
          <td style="padding: 8px; border-bottom: 1px solid #e0e0e0;">${row.description}</td>
          <td style="padding: 8px; border-bottom: 1px solid #e0e0e0; text-align: right; font-weight: 500; color: ${row.amount >= 0 ? '#34a853' : '#ea4335'};">${row.amount >= 0 ? '+' : ''}${formatNumber(row.amount)} g</td>
        </tr>
      `;
    }).join('');
    
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html>
      <head>
        <title>RELEVE COMPTE POIDS - ${clientName}</title>
        <style>
        body { font-family: Arial, sans-serif; padding: 30px; max-width: 800px; margin: 0 auto; }
        .header { text-align: center; margin-bottom: 30px; padding-bottom: 20px; }
        .logo { max-height: 80px; margin-bottom: 15px; }
        h1 { color: #202124; margin: 0 0 5px 0; font-size: 24px; }
        .period-info { color: #5f6368; font-size: 14px; margin: 10px 0 0 0; text-align: center; font-weight: 600; }
        .period-total { font-size: 18px; font-weight: 700; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th { padding: 12px 8px; text-align: left; border-bottom: 2px solid #202124; font-weight: 600; color: #5f6368; font-size: 14px; }
        td { font-size: 14px; color: #202124; }
        .total-row { border-top: 2px solid #202124; font-weight: 700; background: #f8f9fa; }
        .total-row td { padding: 12px 8px; }
        </style>
      </head>
      <body>
        <div class="header">
        <img src="${logoSvg}" alt="Logo" class="logo" style="max-height: 80px; margin-bottom: 15px;">
        <h1>RELEVE COMPTE POIDS - ${clientName}</h1>
        <p class="period-info">Solde Période ${dateDebut ? formatDate(dateDebut) : '...'} - ${dateFin ? formatDate(dateFin) : '...'} : <span class="period-total">${formatNumber(totalPeriode)} g</span></p>
        </div>
        <table>
        <thead>
          <tr>
          <th style="width: 120px;">Date</th>
          <th>Description</th>
          <th style="width: 150px; text-align: right;">Montant Or 750</th>
          </tr>
        </thead>
        <tbody>
          ${soldeAntRow}
          ${movementRows}
          <tr class="total-row">
          <td colspan="2">TOTAL</td>
          <td style="text-align: right; color: ${totalNet >= 0 ? '#34a853' : '#ea4335'};">${formatNumber(totalNet)} g</td>
          </tr>
        </tbody>
        </table>
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.32)',
          zIndex: 9998,
          animation: 'fadeIn 0.2s'
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: '600px',
          maxWidth: '90vw',
          backgroundColor: '#fff',
          boxShadow: '0 8px 32px rgba(0,0,0,0.24)',
          zIndex: 9999,
          display: 'flex',
          flexDirection: 'column',
          animation: 'slideInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      >
        <div style={{ 
          padding: '20px 24px', 
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: 500, color: '#202124' }}>
              Détail des opérations
            </h3>
            <p style={{ margin: '4px 0 0', fontSize: '14px', color: '#5f6368' }}>{clientName}</p>
            {(dateDebut || dateFin) && (
              <p style={{ margin: '6px 0 0', fontSize: '13px', color: '#1a73e8', fontWeight: 500 }}>
                Période: {dateDebut ? formatDate(dateDebut) : '...'} - {dateFin ? formatDate(dateFin) : '...'}
              </p>
            )}
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <button
              onClick={handlePrint}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '20px',
                color: '#5f6368',
                cursor: 'pointer',
                padding: '8px',
                lineHeight: '1',
                display: 'flex',
                alignItems: 'center'
              }}
              title="Imprimer"
            >
              <Print fontSize="small" />
            </button>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                color: '#5f6368',
                cursor: 'pointer',
                padding: '8px',
                lineHeight: '1'
              }}
            >
              ×
            </button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 24px' }}>
          {loading && (
            <div style={{ padding: '40px', textAlign: 'center', color: '#5f6368' }}>
              Chargement...
            </div>
          )}

          {!loading && operations.length === 0 && (
            <div>
              {dateDebut && soldeAnterieur !== 0 && (
                <div
                  style={{
                    padding: '16px',
                    backgroundColor: '#fff3cd',
                    borderRadius: '8px',
                    borderLeft: '4px solid #856404',
                    marginBottom: '16px'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontSize: '14px', fontWeight: 600, color: '#856404', marginBottom: '4px' }}>
                        SOLDE ANTÉRIEUR
                      </div>
                      <div style={{ fontSize: '12px', color: '#856404' }}>
                        Solde avant le {formatDate(dateDebut)}
                      </div>
                    </div>
                    <span style={{
                      fontSize: '18px',
                      fontWeight: 700,
                      color: soldeAnterieur >= 0 ? '#34a853' : '#ea4335'
                    }}>
                      {formatNumber(soldeAnterieur)} g (750)
                    </span>
                  </div>
                </div>
              )}
              <div style={{ padding: '40px', textAlign: 'center', color: '#5f6368' }}>
                {dateDebut || dateFin 
                  ? 'Aucune opération dans l\'intervalle de date sélectionné'
                  : 'Aucune opération'
                }
              </div>
            </div>
          )}

          <div id="operations-print-content" style={{ display: sortedOperations.length > 0 ? 'block' : 'none' }}>
            <h2 style={{ display: 'none' }}>Détail opérations - {clientName}</h2>
            
            {!loading && sortedOperations.length > 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {dateDebut && soldeAnterieur !== 0 && (
                  <div
                    style={{
                      padding: '16px',
                      backgroundColor: '#fff3cd',
                      borderRadius: '8px',
                      borderLeft: '4px solid #856404'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontSize: '14px', fontWeight: 600, color: '#856404', marginBottom: '4px' }}>
                          SOLDE ANTÉRIEUR
                        </div>
                        <div style={{ fontSize: '12px', color: '#856404' }}>
                          Solde avant le {formatDate(dateDebut)}
                        </div>
                      </div>
                      <span style={{
                        fontSize: '18px',
                        fontWeight: 700,
                        color: soldeAnterieur >= 0 ? '#34a853' : '#ea4335'
                      }}>
                        {formatNumber(soldeAnterieur)} g (750)
                      </span>
                    </div>
                  </div>
                )}
                {sortedOperations.map((op, idx) => {
                  const isManuel = op.source === 'MANUEL';
                  const isBroutille = op.type_saisie === 'BROUTILLES';
                  const isAuto = op.source === 'MOUV_CLIENT';
                  const poids750Value = parseFloat(op.poids_750) || 0;
                  const tauxPerte = parseFloat(op.taux_perte) || 0;
                  
                  // Pour broutilles: poids_750 stocke le poids BRUT
                  let poidsBrut, perte, soldeNet;
                  if (isBroutille) {
                    poidsBrut = parseFloat(op.poids_brut) || poids750Value;
                    perte = poidsBrut * tauxPerte / 100;
                    soldeNet = poidsBrut - perte;
                  } else {
                    soldeNet = poids750Value;
                    perte = 0;
                    poidsBrut = 0;
                  }
                  const entreeOrFin = parseFloat(op.entree_or_fin) || 0;
                  const sortieOrFin = parseFloat(op.sortie_or_fin) || 0;
                  const entree750 = isAuto ? (entreeOrFin / 0.751 * 0.95) : (entreeOrFin / 0.75);
                  const sortie750 = sortieOrFin / 0.75;
                  
                  const displayAmount = isBroutille ? soldeNet : (isAuto ? (entree750 - sortie750) : poids750Value);
                  const isEntree = displayAmount > 0;
                  
                  return (
                    <div
                      key={`op-${op.id}-${idx}`}
                      className="operation"
                      style={{
                        padding: '16px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        borderLeft: `4px solid ${isEntree ? '#34a853' : '#ea4335'}`
                      }}
                    >
                      <div className="op-header" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span className="op-type" style={{
                            fontSize: '12px',
                            fontWeight: 500,
                            padding: '2px 8px',
                            borderRadius: '4px',
                            backgroundColor: isManuel ? '#e8f0fe' : '#fce8e6',
                            color: isManuel ? '#1967d2' : '#c5221f'
                          }}>
                            {isManuel ? op.type_saisie : 'AUTO'}
                          </span>
                          <span style={{ fontSize: '12px', color: '#5f6368' }}>
                            {formatDate(op.date_saisie)}
                          </span>
                        </div>
                        <span className="op-amount" style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          color: isEntree ? '#34a853' : '#ea4335'
                        }}>
                          {isEntree ? '+' : ''}{formatNumber(Math.abs(displayAmount))} g (750)
                        </span>
                      </div>
                      
                      <div style={{ fontSize: '14px', color: '#202124', marginBottom: '8px' }}>
                        {op.description || '—'}
                      </div>
                      
                      {isBroutille && (poidsBrut > 0 || tauxPerte > 0) && (
                        <div className="op-details" style={{ fontSize: '12px', color: '#5f6368', backgroundColor: '#fff', padding: '8px', borderRadius: '4px', marginTop: '8px' }}>
                          {poidsBrut > 0 && <div><strong>Poids brut:</strong> {formatNumber(poidsBrut)} g</div>}
                          {tauxPerte > 0 && <div><strong>Taux perte:</strong> {formatNumber(tauxPerte)} %</div>}
                          {perte > 0 && <div style={{ color: '#ea4335' }}><strong>Perte:</strong> {formatNumber(perte)} g</div>}
                          <div style={{ borderTop: '1px solid #e0e0e0', marginTop: '4px', paddingTop: '4px' }}>
                            <strong>Solde net (750):</strong> <span style={{ color: '#1a73e8', fontWeight: 600 }}>{formatNumber(soldeNet)} g</span>
                          </div>
                        </div>
                      )}
                      
                      {isAuto && (entreeOrFin > 0 || sortieOrFin > 0) && (
                        <div className="op-details" style={{ fontSize: '12px', color: '#5f6368', backgroundColor: '#fff', padding: '8px', borderRadius: '4px', marginTop: '8px' }}>
                          {entreeOrFin > 0 && (
                            <>
                              <div><strong>Entrée or fin:</strong> {formatNumber(entreeOrFin)} g</div>
                              <div><strong>Entrée or 750 (/ 0.751 * 0.95):</strong> {formatNumber(entreeOrFin / 0.751 * 0.95)} g</div>
                            </>
                          )}
                          {sortieOrFin > 0 && (
                            <>
                              <div><strong>Sortie or fin:</strong> {formatNumber(sortieOrFin)} g</div>
                              <div><strong>Sortie or 750 (/ 0.75):</strong> {formatNumber(sortieOrFin / 0.75)} g</div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {!loading && sortedFacturesFacon && sortedFacturesFacon.length > 0 && (
            <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '2px solid #e0e0e0' }}>
              <h4 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600, color: '#202124' }}>
              Factures à façon ({sortedFacturesFacon.length} = {formatNumber(sortedFacturesFacon.reduce((sum, fac) => sum + (parseFloat(fac.poids) || 0), 0))} g)
              </h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {sortedFacturesFacon.map((fac, idx) => (
                  <div
                    key={`fac-${fac.fact}-${idx}`}
                    style={{
                      padding: '12px',
                      backgroundColor: '#f8f9fa',
                      borderRadius: '4px',
                      fontSize: '13px',
                      borderLeft: '3px solid #fbbc04'
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                      <span style={{ fontWeight: 500, color: '#202124' }}>
                        Facture #{fac.fact}
                      </span>
                      <span style={{ color: '#5f6368', fontSize: '12px' }}>
                        {fac.date_fact}
                      </span>
                    </div>
                    <div style={{ color: '#5f6368', fontSize: '12px' }}>
                      <div><strong>Réf:</strong> {fac.ref} • <strong>Réf client:</strong> {fac.ref_clt || '—'}</div>
                      <div><strong>Poids:</strong> {formatNumber(fac.poids)} g</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div style={{ 
          padding: '16px 24px', 
          borderTop: '1px solid #e0e0e0',
          backgroundColor: '#f8f9fa'
        }}>
          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#1967d2',
              backgroundColor: '#fff',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Fermer
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </>
  );
};

export default OperationsDrawer;
